<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="JoszakiMarkdownTextBlock" v-html="md.render(text)" />
</template>

<script>
import markdownit from "markdown-it";
export default {
  name: "JoszakiMarkdownTextBlock",
  props: {
    text: {
      type: String,
      required: true,
    },
    addAnchorsToHeadings: {
      type: Boolean,
      default: false,
    },
    openLinksInNewTab: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const md = markdownit({
      html: true,
    });

    if (props.openLinksInNewTab) {
      const proxy = (tokens, idx, options, _, self) =>
        self.renderToken(tokens, idx, options);
      const defaultLinkOpenRenderer = md.renderer.rules.link_open || proxy;

      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        token.attrSet("target", "_blank");
        return defaultLinkOpenRenderer(tokens, idx, options, env, self);
      };
    }

    // lazy load images
    md.renderer.rules.image = (tokens, idx, options, env, self) => {
      const token = tokens[idx];
      token.attrSet("loading", "lazy");
      return self.renderToken(tokens, idx, options, env, self);
    };

    return {
      md,
    };
  },
  mounted() {
    document
      .querySelectorAll(".JoszakiMarkdownTextBlock > h2")
      .forEach((value) => {
        value.id = this.$helpers.stringToSlug(value.textContent);
      });
  },
};
</script>

<style lang="scss">
.JoszakiMarkdownTextBlock {
  font-family: Nunito, sans-serif;

  @media only screen and (max-width: 768px) {
    overflow-x: scroll;
  }

  h1 {
    @apply text-2xl lg:text-4xl pt-2 pb-1 font-bold text-primary;
  }

  h2 {
    @apply text-xl lg:text-3xl pt-2 pb-1 font-bold text-primary;
  }

  h3 {
    @apply text-lg lg:text-2xl pt-2 pb-1 font-bold text-primary;
  }

  h4 {
    @apply text-base lg:text-xl pt-2 pb-1 font-bold text-primary;
  }

  h5 {
    @apply text-base lg:text-lg pt-2 pb-1 font-semibold text-primary;
  }

  p {
    margin-top: 0.5rem;
    text-align: justify;
  }

  img {
    margin-top: 10px;
    @apply md:max-w-[450px] md:mx-auto;
  }

  & > ul,
  & > ol {
    margin-top: 15px;
    margin-bottom: 25px;

    & > li {
      font-family: Nunito, sans-serif;
      margin-left: 20px;

      list-style-type: disc;
      list-style-position: outside;
    }
  }

  & > ol > li {
    list-style-type: decimal;
  }

  table {
    @apply w-full border-collapse mb-4 bg-white;

    th,
    td {
      @apply border border-gray-300 px-2 md:px-3 py-2 align-middle text-sm;
    }

    tr {
      @apply hover:bg-gray-100;
    }

    tr.category-header {
      @apply bg-primary-light text-white font-bold text-center;
    }
  }

  blockquote {
    @apply bg-white p-4 border border-gray-300 border-l-4 border-l-primary-light my-4;
    p {
      margin-top: 0;
    }
  }

  &.bg-primary * {
    color: white !important;
  }
}
</style>
